import React from 'react';
import Swiper from 'react-id-swiper';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';
import ModalVideo from 'react-modal-video';

// ES6 className-style
class OtherLearning extends PreLoginSessionCheck {

	constructor () {
		super()
		this.state = {
		  isOpen: false
		}
		this.openModal = this.openModal.bind(this)
		this.goNext = this.goNext.bind(this)
    	this.goPrev = this.goPrev.bind(this)
	}

	goNext() {
	    if (this.swiper) this.swiper.slideNext()
	}
	 
	goPrev() {
	    if (this.swiper) this.swiper.slidePrev()
	}

	openModal (someValue) {
	    this.setState({isOpen: true})
	    this.videoId = someValue
	}

  render() {
  	const videoId = '';
	const params = {
  		slidesPerView: 3,
  		spaceBetween: 30,
	 	navigation: {
	        nextEl: '.swiper-button-next',
	        prevEl: '.swiper-button-prev',
	        nextButtonCustomizedClass:'.swp-next',
	    	prevButtonCustomizedClass:'.swp-prev'	
	    },
	    containerClass: 'our-learning learning-slider swiper-container swiper-container-horizontal',
	    breakpoints: {
		    480: {
		      slidesPerView: 1,
		      spaceBetween: 20
		    },
		    640: {
		      slidesPerView: 2,
		      spaceBetween: 30
		    },
		    768: {
		      slidesPerView: 2,
		      spaceBetween: 30
		    }
		}
    }

  	return(
  		<section className="mtb whyhm pro-detail student">
		 	<div className="row">
		 		<div className="container">
		 			<h3>We collaborate closely with teachers</h3>
		 			<div className="row"> 
			 			<Swiper className="our-learning learning-slider" breakpoints={params.breakpoints}  slidesPerView={params.slidesPerView} spaceBetween={params.spaceBetween} containerClass={params.containerClass} ref={node => {if(node) this.swiper = node.swiper}}>
 							<div className="swiper-slide">
	 							<div data-ga="Our Learnings - We collaborate closely with teachers - Karen Dickey" onClick={this.openModal.bind(null,'MMbIMB1eQ9U')} className="learn-box popup-youtube collaborate-img">
 									<img src="../img/learn1.jpg" alt=""/>
 									<span className="play-btn"></span>
	 							</div>
	 						</div>

 							<div className="swiper-slide">
	 							<div data-ga="Our Learnings - We collaborate closely with teachers - Maheshwari Natarajan" onClick={this.openModal.bind(null,'RGZ8kSxUi8Y')} className="learn-box popup-youtube collaborate-img">
 									<img src="../img/learn2.jpg" alt=""/>
 									<span className="play-btn"></span>
	 							</div>
	 						</div>

 							<div className="swiper-slide">
	 							<div data-ga="Our Learnings - We collaborate closely with teachers - Swathi Ashar" onClick={this.openModal.bind(null,'5QyaHbY6EX0')} className="learn-box popup-youtube collaborate-img">
 									<img src="../img/learn3.jpg" alt=""/>
 									<span className="play-btn"></span>
	 							</div>
	 						</div>
	 						
	 						<div className="swiper-slide">
	 							<div data-ga="Our Learnings - We collaborate closely with teachers - Ms Jemila" onClick={this.openModal.bind(null,'Yqqb_xHarMQ')} className="learn-box popup-youtube collaborate-img">
 									<img src="../img/learn4.jpg" alt=""/>
 									<span className="play-btn"></span>
	 							</div>
	 						</div>
	 						
	 						<div className="swiper-slide">
	 							<div data-ga="Our Learnings - We collaborate closely with teachers - Meena Meyyappan" onClick={this.openModal.bind(null,'c3Z2ty6gwv4')} className="learn-box popup-youtube collaborate-img">
 									<img src="../img/learn5.jpg" alt=""/>
 									<span className="play-btn"></span>
	 							</div>
	 						</div>
	 						
	 						<div className="swiper-slide">
	 							<div data-ga="Our Learnings - We collaborate closely with teachers - N Rama Devi" onClick={this.openModal.bind(null,'jKx6LKHFIqs')} className="learn-box popup-youtube collaborate-img">
 									<img src="../img/learn6.jpg" alt=""/>
 									<span className="play-btn"></span>
	 							</div>
	 						</div>
			 			</Swiper>
			 			<div className="slider-btns">
			        		<div className="swiper-button-prev swp-prev" onClick={this.goPrev}></div>
			        		<div className="swiper-button-next swp-next" onClick={this.goNext}></div>
		        		</div>	
		 			</div> 
		 		</div>
		 	</div>
		 	<ModalVideo channel='youtube' isOpen={this.state.isOpen} videoId={this.videoId} onClose={() => this.setState({isOpen: false})} /> 
		 </section> 
  	);
  }
}

export default OtherLearning;


// WEBPACK FOOTER //
// ./src/prelogin/src/components/OtherLearnings.js